import { parseCurrency } from '@helper/parseCurrency'

export const parseStoreHeaderBudgetData = (data: any[]): any[] => {
  const res = []
  let realProj = 0
  let levOrc = 0
  let cresc = 0
  let orca = 0
  let cresAjust = 0
  data.forEach(obj => {
    return (realProj += obj.realizadoAnoPassado)
  })
  data.forEach(obj => {
    return (levOrc += obj.previsaoAnoAtual)
  })
  data.forEach(obj => {
    return (cresc += obj.previsaoAumentoPercentual)
  })
  data.forEach(obj => {
    return (orca += obj.previsaoAjusteFino)
  })
  data.forEach(obj => {
    return (cresAjust += obj.previsaoAumentoPercentualAjusteFino)
  })

  res.push({
    'orcamento-id': '',
    'orcamento-ano': '',
    'orcamento-empresa': '',
    'orcamento-loja': '',
    'orcamento-fator-venda': '',
    'orcamento-real-ano-atual': parseCurrency({
      value: realProj,
      country: 'pt-br'
    }),
    'orcamento-previsao-orcamento': parseCurrency({
      value: levOrc,
      country: 'pt-br'
    }),
    'orcamento-crescimento-perc': parseCurrency({
      value: cresc,
      country: 'pt-br'
    }),
    'orcamento-ajustado': parseCurrency({
      value: orca,
      country: 'pt-br'
    }),

    'orcamento-alterado': '',
    'orcamento-crescimento-ajustado': parseCurrency({
      value: cresAjust,
      country: 'pt-br'
    }),
    'orcamento-du-proj-ano-atual': '',
    'orcamento-du-previsao-orcamento': '',
    'orcamento-du-ajustado': ''
  })

  return res
}
